import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    milestoneFull: 'b-brand-1 bg-brand-1',
    milestoneEmpty: 'b-grey-60 bg-white',
    milestoneBar: 'bg-brand-1'
  },
} satisfies VfConfig['milestoneBar']
